import React, { useState, useEffect } from 'react';
import { useToast } from '../../../hooks/useToast';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../../src/firebase';

const defaultContents: Record<string, string> = {
  'robots_txt': "User-agent: *\nAllow: /\n\nSitemap: https://brandgenius.app/sitemap.xml\nSitemap: https://brandgenius.app/sitemap-posts.xml",
  'llms_txt': "# BrandGenius\n\nBrandGenius is an AI-powered branding and naming platform.",
  'ads_txt': ""
};

export const ManageTextFiles: React.FC = () => {
  const [activeFile, setActiveFile] = useState<string>('robots_txt');
  const [fileContent, setFileContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const { showToast } = useToast();

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'appContent', activeFile);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setFileContent(docSnap.data().content || defaultContents[activeFile]);
        } else {
          setFileContent(defaultContents[activeFile]);
        }
      } catch (e) {
        console.error(`Error fetching ${activeFile}`, e);
      }
      setLoading(false);
    };
    fetchContent();
  }, [activeFile]);

  const handleSave = async () => {
    try {
      const docRef = doc(db, 'appContent', activeFile);
      await setDoc(docRef, { content: fileContent }, { merge: true });
      showToast(`${activeFile.replace('_', '.')} saved successfully!`);
    } catch (e) {
      console.error(`Error saving ${activeFile}`, e);
      showToast('Error saving file', 'error');
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-bold text-gray-900 mb-4">Manage Text Files</h3>
      
      <div className="flex gap-4 mb-6">
        <button 
          onClick={() => setActiveFile('robots_txt')}
          className={`px-4 py-2 rounded-md ${activeFile === 'robots_txt' ? 'bg-indigo-100 text-indigo-700 font-bold' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          robots.txt
        </button>
        <button 
          onClick={() => setActiveFile('llms_txt')}
          className={`px-4 py-2 rounded-md ${activeFile === 'llms_txt' ? 'bg-indigo-100 text-indigo-700 font-bold' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          llms.txt
        </button>
        <button 
          onClick={() => setActiveFile('ads_txt')}
          className={`px-4 py-2 rounded-md ${activeFile === 'ads_txt' ? 'bg-indigo-100 text-indigo-700 font-bold' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          ads.txt
        </button>
      </div>

      {loading ? (
        <div className="py-10 text-center">Loading...</div>
      ) : (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Edit {activeFile.replace('_', '.')}
          </label>
          <textarea
            value={fileContent}
            onChange={(e) => setFileContent(e.target.value)}
            rows={15}
            className="w-full px-4 py-3 border border-gray-300 rounded-md font-mono text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          ></textarea>
          
          <div className="mt-4 flex justify-end">
            <button
              onClick={handleSave}
              className="px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-md shadow-sm transition-colors"
            >
              Save File
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
